export default __webpack_public_path__ + "media/pro/channel-7eaf1f10.svg";